import { cn } from '../../lib/util'
import { BadgeV1Props } from './badge-v1.types'

import { badgeV1Variants } from './badge-v1.css'

/**
 * @deprecated Use Badge instead
 */
const BadgeV1 = ({ className, variant = 'default', ...props }: BadgeV1Props) => {
  return <div className={cn(badgeV1Variants({ variant }), className)} {...props} />
}

export default BadgeV1
